
export const MassActionTypes = {
   UPDATE_MASSES: 'UPDATE_MASSES',
   RESET_MASSES: 'RESET_MASSES',
   UPDATE_CONFIG: 'UPDATE_CONFIG',
   UPDATE_TYPES: 'UPDATE_TYPES',
};


export const MassStatusTypes = {
   MASS_FULL: 'MASS_FULL',
   MASS_CLOSED: 'MASS_CLOSED',
   MASS_OPEN: 'MASS_OPEN',
   MASS_NOT_OPEN: 'MASS_NOT_OPEN'
};

export const MassBKGColors = {
   FULL_COLOR: '#600000',
   OPEN_SOON_COLOR: '#336633',
   CLOSED_COLOR: '#663366'
};